export default "__VITE_ASSET__DFgTmXt7__"